module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/nl-card-drag.d5eccf2138252d174ecc.gif";